module.exports = __webpack_public_path__ + "static/media/HARMONY.e083a829.svg";